import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";
import CreateRoles from "./CreateRoles";
import UpdateRoles from "./UpdateRoles";
import ViewRole from "./ViewRole";
import RolePermissionManager from "./RolePermissionManager";

const Roles = ({ match }) => {
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  return (
    <>
      <Switch>
        <Route exact path={`${match.path}`} component={RolePermissionManager} />
        <Route exact path={`${match.path}/view`} component={ViewRole} />
        <Route exact path={`${match.path}/create`} component={CreateRoles} />
        <Route path={`${match.path}/:id/detail`} component={CreateRoles} />
        {/* <Redirect from="" to={`${match.path}`} /> */}
      </Switch>
    </>
  );
};

export default Roles;
